export interface Artifact {
  id: number;
  artifact: number;
  description: string;
  actions: number[];
}

export const artifactsRows: Artifact[] = [
  {
    id: 3,
    artifact: 3,
    description:
      '<p class="fw-bold">Evaluation Proposal</p><p>The following information is included in the online evaluation proposal form: Vendor Contact information, PP Conformance Claim, General Product Information, status of NIST evaluation "if needed", expected Check-in Package delivery date.</p>',
    actions: [2],
  },
  {
    id: 5,
    artifact: 5,
    description:
      '<p class="fw-bold">Evaluation Record</p><p>The official means to document the evaluation and metrics associated with conducting the evaluation, and to document information associated with the Vendor, the Validator, and the Lab.  As an official document for the evaluation, the <b>Evaluation Record</b> is archived when the evaluation completes.</p>',
    actions: [4],
  },
  {
    id: 7,
    artifact: 7,
    description:
      '<p class="fw-bold">Security Target "ST"</p><p>Contents is as specified by the Common Criteria Part 1, Annex A, available on the NIAP website and the Common Criteria Portal.  The NIST evaluation dependency is documented as one of the following:</p>  <ul><li><b>None</b></li><li><b>In Progress</b></li><li><b>Completed</b></li></ul></p><p>For the case of an <i>In Progress </i> NIST evaluation, the Vendor is to monitor the NIST evaluation.</p>',
    actions: [6, 11, 12, 13],
  },
  {
    id: 9,
    artifact: 9,
    description:
      '<p class="fw-bold">Entropy Assessment Report "EAR"</p><p>Contains the "Entropy Documentation and Assessment" as defined by the Protection Profile Annex.</p>',
    actions: [8, 11, 12, 13, 14, 15],
  },
  {
    id: 12,
    artifact: 12,
    description:
      '<p class="fw-bold">Check-in Package</p><p>The Check-in Package for the product that is to be evaluated includes:<ul><li>Security Target "ST"</li><li>Entropy Assessment Report "EAR"</li><li>NIST evaluation dependency and status</li><li>Product guidance documents, if available, including:</li><ul><li>Admin Guide</li><li>User Guide</li><li>Configuration Guide</li><li>Interface Descriptions</li></ul><li>Other technology-specific information specific to the product</li></ul></p><p>Progress Point 1 is associated with delivery of the <b>Check-in Package</b> to NIAP.  The Check-in Packageshould be posted to the NIAP evaluation document repository.</p>',
    actions: [7, 9, 10, 11, 17, 19],
  },
  {
    id: 26,
    artifact: 26,
    description:
      '<p class="fw-bold">Evaluation Issue Resolution Decision</p><p>The course of action NIAP authorizes to resolve an identified issue.  The decision may include:<ul><li>Parties responsible for resolving the issue</li><li>Course of action</li><li>Reporting associated with issue resolution</li><li>Impact on evaluation clock</li><li>Resolution deadline dates.</li></ul></p>',
    actions: [25, 27],
  },
  {
    id: 30,
    artifact: 30,
    description:
      '<p class="fw-bold">Lab Status Updates</p><p>The method for labs to provide regular evaluation status information to NIAP for evaluation progress monitoring, auditing, and accounting purposes.  Lab Status Updates are provided weekly "using Lab Acknowledgement facility" and include planned and actual completion dates for Progress Points 3 through 6 "see Progress Points Definition Table". </p>',
    actions: [29],
  },
  {
    id: 32,
    artifact: 32,
    description:
      '<p class="fw-bold">Sync Session Notes</p><p>Used to record the results of NIAP, Validator, Lab Sync "status update" meetings.  The documentation includes:<ul><li>Any issue(s) addressed</li><li>Issue(s) resolution decisions</li><li>Issue(s) resolution rationale</li><li>Reference materials consulted</li><li>Coordination with a TRRT</li><li>Official meeting minutes</li><li>Outcomes</li></ul></p><p><b> Note:</b> Documentation of the Sync Session is maintained by NIAP as part of the <b>Evaluation Record,</b> and should be posted to the NIAP evaluation document repository.</p>',
    actions: [5, 30, 31],
  },
  {
    id: 35,
    artifact: 35,
    description:
      '<p class="fw-bold">NIST Evaluation Evidence</p><p>Consists of a certificate from NIST to document the completion of the NIST evaluation.</p>',
    actions: [33, 34, 38, 44],
  },
  {
    id: 37,
    artifact: 37,
    description:
      '<p class="fw-bold">Evaluator Check Out Section</p><p>The primary technical portion of the Check-out Package. It includes the following:<ul><li>Evaluation Technical Report "ETR"</li><li>Assurance Activities Report "Publicly Releasable"</li><li>Final <b>Entropy Assessment Report "EAR"</b></li><li>NIST completion evidence</li><li><b>Check-in Package</b></li></ul><b>Note: </b>The Check In Package may be revised during the course of the product evaluation.</p>',
    actions: [9, 12, 35, 36, 38, 39, 40, 41],
  },
  {
    id: 44,
    artifact: 44,
    description:
      '<p class="fw-bold">Validator Check-Out Section</p><p>Comprised of:<ul><li>Validation Report</li><li>Product Compliant List "PCL" entry information </li></ul></p>',
    actions: [42, 43],
  },
  {
    id: 46,
    artifact: 46,
    description:
      '<p class="fw-bold">Vendor Check-Out Section</p><p>Comprised of:<ul><li>Sponsor Approval to List "Form F8001" </li><li>CCEVS Certificate Worksheet "Form F8003" </li><li>End of Evaluation Survey "Form F8004" </li></ul></p>',
    actions: [45],
  },
  {
    id: 47,
    artifact: 47,
    description:
      '<p class="fw-bold">Check-Out Package</p><p>Includes the following sections:<ul><li><b>Evaluator Check-Out Section</b></li><li><b>Validator Check-Out Section</b></li><li><b> Vendor Check-Out Section</b></li></ul></p>',
    actions: [37, 44, 46],
  },
  {
    id: 50,
    artifact: 50,
    description:
      '<p class="fw-bold">Evaluation Certificate</p><p>Documents that a product has successfully completed the NIAP evaluation process.</p>',
    actions: [48, 49, 51],
  },
];
